import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Lang, Lang_$reflection } from "../Shopfoo.Domain.Types/Common.js";
import { class_type, record_type, unit_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Remote$1, Remote$1_$reflection } from "../Remoting.js";
import { find, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { map, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { JS_blurActiveElement } from "../UI.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { icon } from "./Icon.js";
import check from "@iconify-icons/fa6-solid/check";
import circle_exclamation from "@iconify-icons/fa6-solid/circle-exclamation";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import language from "@iconify-icons/fa6-solid/language";

export class LangMenu extends Record {
    constructor(Lang, Code, Label, Emoji, Status) {
        super();
        this.Lang = Lang;
        this.Code = Code;
        this.Label = Label;
        this.Emoji = Emoji;
        this.Status = Status;
    }
}

export function LangMenu_$reflection() {
    return record_type("Shopfoo.Client.Components.Lang.LangMenu", [], LangMenu, () => [["Lang", Lang_$reflection()], ["Code", string_type], ["Label", string_type], ["Emoji", string_type], ["Status", Remote$1_$reflection(unit_type)]]);
}

function LangMenuModule_mk(lang, code, label, emoji) {
    return new LangMenu(lang, code, label, emoji, new Remote$1(3, [undefined]));
}

export const LangMenuModule_all = ofArray([LangMenuModule_mk(new Lang(0, []), "en", "English", "ᴇɴ"), LangMenuModule_mk(new Lang(1, []), "fr", "Français", "ꜰʀ"), LangMenuModule_mk(new Lang(2, []), "la", "Latin ⚠️", "ʟᴀ")]);

function Shopfoo_Domain_Types_Common_Lang__Lang_get_AsModel(lang) {
    return find((lg) => equals(lg.Lang, lang), LangMenuModule_all);
}

class LangMenuElement {
    constructor(currentLang, onClick) {
        this.currentLang = currentLang;
        this.onClick = onClick;
    }
}

function LangMenuElement_$reflection() {
    return class_type("Shopfoo.Client.Components.Lang.LangMenuElement", undefined, LangMenuElement);
}

function LangMenuElement_$ctor_150BFB0A(currentLang, onClick) {
    return new LangMenuElement(currentLang, onClick);
}

function LangMenuElement__li_Z3835E877(_, key, langMenu, canClick, isSelected) {
    return (statusElement) => {
        let elems_1;
        return createElement("li", createObj(ofArray([["key", `${key}-li`], ["className", "aria-selected:bg-base-300 rounded"], ["aria-selected", defaultArg(isSelected, false)], (elems_1 = [createElement("a", createObj(toList(delay(() => append(singleton(["key", `${key}-link`]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("whitespace-nowrap"), delay(() => (!canClick ? append(singleton("cursor-default"), delay(() => singleton("opacity-60"))) : empty()))))))]), delay(() => append(canClick ? singleton(["onClick", (_arg) => {
            _.onClick(langMenu.Lang);
            JS_blurActiveElement();
        }]) : singleton(["aria-disabled", true]), delay(() => {
            let elems;
            return singleton((elems = [createElement("span", {
                key: `${key}-label`,
                children: `${langMenu.Emoji}  ${langMenu.Label}`,
            }), statusElement], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    };
}

function LangMenuElement__item_Z51C8598F(this$, langMenu) {
    const key = `lang-${langMenu.Code}`;
    const isCurrentLang = equals(langMenu.Lang, this$.currentLang);
    const matchValue = langMenu.Status;
    switch (matchValue.tag) {
        case 1:
            return LangMenuElement__li_Z3835E877(this$, key, langMenu, false)(createElement("span", createObj(Helpers_combineClasses("loading", ofArray([["key", `${key}-spinner`], ["className", "loading-spinner"], ["className", "loading-xs"], ["className", "text-info"]])))));
        case 3:
            return LangMenuElement__li_Z3835E877(this$, key, langMenu, !isCurrentLang, isCurrentLang)(createElement("span", createObj(toList(delay(() => append(singleton(["key", `${key}-status`]), delay(() => append(singleton(["className", "ml-auto font-bold text-green-500 min-w-[1em]"]), delay(() => (isCurrentLang ? singleton(["children", icon(check)]) : empty()))))))))));
        case 2:
            return LangMenuElement__li_Z3835E877(this$, key, langMenu, true)(createElement("div", createObj(Helpers_combineClasses("tooltip", ofArray([["key", `${key}-error-tooltip`], ["className", "text-error"], ["children", icon(circle_exclamation)], ["data-tip", `Error: ${matchValue.fields[0].ErrorMessage}`]])))));
        default:
            return defaultOf();
    }
}

export function LangDropdown(langDropdownInputProps) {
    let elems_2, elems_1, elems;
    const onClick = langDropdownInputProps.onClick;
    const menus = langDropdownInputProps.menus;
    const currentLang = langDropdownInputProps.currentLang;
    const key = langDropdownInputProps.$key;
    return createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["className", "dropdown-hover"], ["className", "dropdown-end"], ["key", `${key}-dropdown`], ["className", "flex-none"], (elems_2 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-ghost"], ["key", "lang-button"], ["className", "opacity-80 hover:opacity-100"], ["children", icon(language)]])))), createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", "lang-dropdown-content"], ["className", "p-2 shadow menu bg-base-100 rounded-box"], ["tabIndex", 0], (elems_1 = [createElement("ul", createObj(ofArray([["key", "lang-dropdown-list"], (elems = toList(delay(() => {
        const menuElement = LangMenuElement_$ctor_150BFB0A(currentLang, onClick);
        return map((menu) => LangMenuElement__item_Z51C8598F(menuElement, menu), menus);
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
}

